import { IBorderRadiusStyle, IBorderWidthStyle } from './Interfaces';
import { BorderRadius, BorderWidth } from './Enums';

export const BorderRadiusStyle: { [key in BorderRadius]: IBorderRadiusStyle } = {
  none: {
    none: '0',
    sm: '0',
    DEFAULT: '0',
    md: '0',
    lg: '0',
    xl: '0',
    '2xl': '0',
    '3xl': '0',
    '4xl': '0',
    '5xl': '0',
    '6xl': '0',
    full: '0',
  },
  small: {
    none: '0',
    sm: '0.125rem',
    DEFAULT: '0.25rem',
    md: '0.375rem',
    lg: '0.5rem',
    xl: '0.75rem',
    '2xl': '1rem',
    '3xl': '1.5rem',
    '4xl': '2.5rem',
    '5xl': '3rem',
    '6xl': '4.5rem',
    full: '9999px',
  },
  medium: {
    none: '0',
    sm: '0.425rem',
    DEFAULT: '0.65rem',
    md: '0.775rem',
    lg: '0.9rem',
    xl: '1.15rem',
    '2xl': '5rem',
    '3xl': '5.5rem',
    '4xl': '7.5rem',
    '5xl': '7rem',
    '6xl': '8.5rem',
    full: '9999px',
  },
};

export const BorderWidthStyle: { [key in BorderWidth]: IBorderWidthStyle } = {
  none: {
    none: '0px',
    sm: '0px',
    DEFAULT: '0px',
    md: '0px',
    lg: '0px',
  },
  light: {
    none: '0px',
    DEFAULT: '1.5px',
    sm: '1px',
    md: '2px',
    lg: '3px',
  },
  small: {
    none: '0px',
    DEFAULT: '1.5px',
    sm: '1px',
    md: '2px',
    lg: '3px',
  },
  medium: {
    none: '0px',
    DEFAULT: '3.5px',
    sm: '3px',
    md: '4px',
    lg: '5px',
  },
};
